'use strict'

const { installSiteProtection } = require('./siteProtection')
const installImageProtection = installSiteProtection

module.exports = { installImageProtection }



// WEBPACK FOOTER //
// ./src/lib/imageProtection.js